import { Injectable } from '@angular/core';
import { SupportDataForm } from '../_models/support-data-form';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable} from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})

export class SupportService {
  public static readonly URL_SUPPORT_CONTROLLER = environment.apiUrl + '/support';

  // Support
  public static readonly URL_SAVE_SUPPORT_DETAILS = SupportService.URL_SUPPORT_CONTROLLER + "/saveSupportDetails/";

  constructor(private http: HttpClient,private authService: AuthService) { }

  saveSupportDetails(supportDataForm: SupportDataForm) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(SupportService.URL_SAVE_SUPPORT_DETAILS + '/' + userToken, supportDataForm)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse) => {
      if (error.status === 401) {
        localStorage.removeItem('currentUser');
        window.location.replace('');
      }
      return Observable.throw(error);
    };
  }
}
